import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ReAutheticateComponent } from '../re-autheticate/re-autheticate.component';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
    selector: 'app-digital-signature',
    templateUrl: './digital-signature.component.html',
    styleUrls: ['./digital-signature.component.scss'],
    standalone: false
})
export class DigitalSignatureComponent implements OnInit {

  validations_form: UntypedFormGroup;
  password: string = '';
  role:string ='';
  comment:string = '';
  hidePassword: boolean = true;
  backgroundColorButton: string;
  backgroundColorScreen: string;
  buttonColor: string;
  roletype :any = [];
 rolelist: any[] = [
  { rolename: "Admin" },
  { rolename: "User" }, 
  { rolename: "SuperAdmin" }
];
  username: string;
   constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ReAutheticateComponent>,private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private constants: constants, private msg: ErrorMessages, private fb: UntypedFormBuilder,
    private localStorageSettings: LocalStorageSettingsService,public dialogref: MatDialogRef<ReAutheticateComponent>,private service:EtlService,private loginService: LoginService, private commonService:CommonService
  ) {
     this.validations_form = this.fb.group({
      password: ['', [Validators.required]],
      username: ['', [Validators.required]],
      role:['',[Validators.required]],
      comment:['']
    });
  }

  ngOnInit(): void {
     this.commonService.getlookupVauleByLookUpType("Role Type For Critical Operation").subscribe(result => {
      console.log(result);
      this.roletype = result;
      console.log(this.roletype)

    });
     if (this.data && this.data.edata && this.data.edata.password) {
      // this.password = this.data.edata.password;
    }
    //  this.formValidation()
     this.username =this.localStorageSettings.getSettings("AuthUser")
   
      console.log(this.localStorageSettings.getSettings("UserId"))
      console.log(this.localStorageSettings.getSettings("AuthUsername"))
        //  var encodepassword = btoa('1234567890')
      
     this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
     this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
   
     if (this.username) {
    this.validations_form.get('username')?.setValue(this.username);
    }
  }
  
  formValidation() {
    this.validations_form = new UntypedFormGroup({
      password: new UntypedFormControl('', [Validators.required]),
      username: new UntypedFormControl('', [Validators.required]),
    })
  }

   togglePassword() {
    this.hidePassword = !this.hidePassword;
  }
  cancel(){
    this.dialogRef.close()
  }
  save(){

     if (this.validations_form.invalid) {
       // mark all fields touched so mat-error shows
        Object.values(this.validations_form.controls).forEach(control => {
          control.markAsTouched();
        });

        this.snackbar.open("All mandatory fields are required", "OK", {
         duration: 5000
        });
        return; 
    }
    const userDto ={
      username:this.localStorageSettings.getSettings("AuthUsername"),
      userId:this.localStorageSettings.getSettings("UserId"),
      password: this.password,
      role:this.role,
      comments:this.validations_form.get('comment')?.value,
      criticaloperationtype:'Digital Signature'
    }
    console.log(userDto)
    const enteredPassword = this.validations_form.get('password')?.value;
    console.log(enteredPassword) 

    userDto.password=enteredPassword
    this.spinner.start()
    this.service.reAuthenticate(userDto).subscribe(res=>{
    console.log(res)
    if(res.error===true){
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      this.spinner.stop();
    }else{
      this.spinner.stop();
       this.dialogRef.close({ data: res })
    }
  })
  }

  Dropdown(event){
    this.role = event.value
  }
}

